import { jsx as o } from "react/jsx-runtime";
import { t as p } from "../../../bundle-mjs-DoW15_-f.js";
import { startOfYearPeriod as Y, Views as b } from "../../../utils/datepicker.js";
import { useDatePickerContext as h } from "../DatepickerContext.js";
const v = () => {
  const {
    theme: n,
    selectedDate: l,
    minDate: r,
    maxDate: a,
    viewDate: i,
    setViewDate: c,
    setView: d
  } = h(), t = n.views.years;
  return /* @__PURE__ */ o("div", { className: t.items.base, children: [...Array(12)].map((g, f) => {
    const e = Y(i, 10) - 1 + f, m = new Date(i.getTime());
    m.setFullYear(e);
    const u = l?.getFullYear() === e;
    let s = !1;
    if (a && r) {
      const D = a?.getFullYear(), w = r?.getFullYear();
      s = e < w || e > D;
    }
    return /* @__PURE__ */ o(
      "button",
      {
        disabled: s,
        type: "button",
        className: p(
          t.items.item.base,
          u && t.items.item.selected,
          s && t.items.item.disabled
        ),
        onClick: () => {
          s || (c(m), d(b.Months));
        },
        children: e
      },
      e
    );
  }) });
};
export {
  v as DatepickerViewsYears
};
